import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ImageShow from '../components/ImageShow';
import useNavigation from '../hooks/use-navigation';
import { useGetPersonalInfoQuery, useUpdatePersonalInfoMutation } from '../store/apis/userInfoApi';

function ProfilePage() {
	const { navigate } = useNavigation();
	const { t } = useTranslation();

		return (
			<div className="page">
				<div className='flex gap-1 items-center mb-1'>
					<span onClick={() => navigate('/cabinet')}>
						<ImageShow
							image={{ url: 'back' }}
							className="mr-2 cursor-pointer"
							
						/>
					</span>
					<h1 className="text-black text-2xl">
						{t('profile.title')}
					</h1>
				</div>
				<p className="mb-10 text-gray-500">
					{t('profile.subtitle')}
				</p>
				<InfoForm />
			</div>
		);
};

const getPersonalInfo = (t) => [
	{ label: t('profile.personalInfo.taxpayerFullName'), inputName: 'taxpayerFullName' },
	{ label: t('profile.personalInfo.contactPhoneNumber'), inputName: 'contactPhoneNumber' },
	{ label: t('profile.personalInfo.taxpayerIdentificationNumber'), inputName: 'taxpayerIdentificationNumber' },
	{ label: t('profile.personalInfo.email'), inputName: 'email' },
];

const getAddressInfo = (t) => [
	{ label: t('profile.addressInfo.postalIndex'), inputName: 'postalIndex' },
	{ label: t('profile.addressInfo.region'), inputName: 'region' },
	{ label: t('profile.addressInfo.district'), inputName: 'district' },
	{ label: t('profile.addressInfo.city'), inputName: 'city' },
	{ label: t('profile.addressInfo.street'), inputName: 'street' },
	{ label: t('profile.addressInfo.block'), inputName: 'block' },
	{ label: t('profile.addressInfo.houseNumber'), inputName: 'houseNumber' },
	{ label: t('profile.addressInfo.apartmentNumber'), inputName: 'apartmentNumber' },
];

function InfoForm() {
	const { t } = useTranslation();

	const [updatePersonalInfo, { status }] = useUpdatePersonalInfoMutation();
	const { data } = useGetPersonalInfoQuery();

	const [buttonText, setButtonText] = useState(t('profile.save'));

	const [formData, setFormData] = useState({
    taxpayerFullName: '',
    contactPhoneNumber: '',
    taxpayerIdentificationNumber: '',
    email: '',
    postalIndex: '',
    region: '',
    district: '',
    city: '',
    street: '',
    block: '',
    houseNumber: '',
    apartmentNumber: '',
  });

	const onSubmit = (e) => {
		e.preventDefault();
		if(status === 'loading') return;

		// const data = new FormData(e.target);
		// const formData = Object.fromEntries(data.entries());

		updatePersonalInfo({ ...formData });
	};

	const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

	const RenderItem = (label, inputName) => {
		return (
			<div className="flex gap-2 p-5 flex-1 bg-gray-200 rounded-2xl items-center lgdef:px-2">
				<label className="flex-1 text-sm min-w-[150px]"> { label } </label>
				<input 
					type="text" 
					className="border-none bg-white p-2 rounded-2xl flex-[2] lgdef:flex-[1.5] xl:flex-[2.5] h-12 focus:outline-none" 
					name={inputName} 
					value={formData[inputName]}
					onChange={handleChange}
				/>
			</div>
		)
	}

	useEffect(() => {
    if (data) {
      setFormData({
        ...formData,
				...data,
      });
    }
  }, [data]);

		useEffect(() => {
			if(status === 'fulfilled') {
				setButtonText(t('profile.saved'));
			}
		}, [status])
	
		useEffect(() => {
			if(buttonText === t('profile.saved')) {
				setTimeout(() => setButtonText(t('profile.save')), 2000);
			}
		}, [buttonText]);

	const personalInfo = getPersonalInfo(t);
	const addressInfo = getAddressInfo(t);

	return (
		<form id='personalInfo' className="flex flex-col gap-4" onSubmit={onSubmit}>
			<div className="grid gap-5">
				<div className="grid grid-cols-1 gap-1 items-stretch lgdef:grid-cols-2 lgdef:gap-5 xl:gap-10">
					<div className="flex flex-col gap-1 justify-center">
						{personalInfo.slice(0, 2).map((item) => RenderItem(item.label, item.inputName))}
					</div>
					<div className="flex flex-col gap-1 justify-center">
						{personalInfo.slice(-2).map((item) => RenderItem(item.label, item.inputName))}
					</div>
				</div>

				<div className="border-b border-grey-400" />
			
				<div className="grid grid-cols-1 gap-1 items-center lgdef:grid-cols-2 lgdef:gap-5 xl:gap-10">
					<div className="flex flex-col gap-1 justify-center">
						{addressInfo.slice(0, 4).map((item) => RenderItem(item.label, item.inputName))}
					</div>
					<div className="flex flex-col gap-1 justify-center">
						{addressInfo.slice(-4).map((item) => RenderItem(item.label, item.inputName))}
					</div>
				</div>
			</div>
			<button 
				className={
					clsx(
						`
							text-sm text-gray-350 mt-1 rounded-md py-2.5 px-4 w-fit
							bg-gradient-to-r from-cyan-650 to-cyan-75 text-white 
							hover:bg-gradient-to-r hover:from-cyan-900 hover:to-cyan-650
						`, 
					)
				}
				type="submit"
			>
				{ buttonText === t('profile.saved') && <span className="mr-2">✓</span> }
				{ status === 'pending' ? t('profile.saving') : buttonText}
				{/* { status === 'loading' ? 'Збереження...' : 'Зберегти'} */}
			</button>
		</form>
	)
}

export default ProfilePage;